import { cn, ErrorState, Skeleton } from '@bloom/ui';
import type { ReactNode } from 'react';
import { COMMON, ERRORS } from '../copy/common';

/** Mobile first: user screens are a single ~480px column, admin gets room. */
export function Page(props: { children: ReactNode; width?: 'user' | 'admin'; className?: string }) {
  return (
    <div
      className={cn(
        'mx-auto w-full px-4 pb-16 pt-6',
        props.width === 'admin' ? 'max-w-5xl' : 'max-w-120',
        props.className,
      )}
    >
      {props.children}
    </div>
  );
}

export function PageTitle(props: { children: ReactNode; sub?: ReactNode }) {
  return (
    <header className="mb-5">
      <h1 className="text-2xl font-semibold leading-tight text-ink">{props.children}</h1>
      {props.sub ? <p className="mt-1.5 text-sm text-ink-muted">{props.sub}</p> : null}
    </header>
  );
}

export function LoadingBlock(props: { rows?: number }) {
  return (
    <div role="status" aria-label={COMMON.loading} className="flex flex-col gap-3">
      {Array.from({ length: props.rows ?? 3 }, (_, index) => (
        <Skeleton key={index} className="h-24 w-full" />
      ))}
    </div>
  );
}

export function LoadFailed(props: { onRetry: () => void; title?: string }) {
  return <ErrorState title={props.title ?? ERRORS.generic} onRetry={props.onRetry} />;
}
